import styled from '@emotion/styled';
import { ThumbDown, ThumbDownFilled } from './ThumbDown';
import { ThumbUp, ThumbUpFilled } from './ThumbUp';
import { ContentCopy /* , ContentCopyFilled */ } from './ContentCopy';
import { ChatMessageViewProps } from './types';
import FeedbackModal from '../FeedbackModal';
import { useState } from 'react';

const ChatMessageWrapper = styled.div<{ isAgent: boolean }>`
  /* hover opacity effect is in parent component */

  margin-top: 12px;
  display: flex;
`;

const SvgWrapper = styled.div`
  margin-right: 8px;

  &:last-child {
    margin-left: 20px;
  }

  & svg {
    cursor: pointer;
  }
`;

const ChatMessageFeedback = (props: ChatMessageViewProps) => {
  const { onFeedbackClick, onCopyClick, feedback, sender, id, content, responseOf } = props;
  const [open, setOpen] = useState(false);

  const isAgent = sender === 'agent';
  const { upvote = false, downvote = false } = feedback || {};

  const onThumbDownClick = () => {
    onFeedbackClick(id, 'down');
    if (downvote) return;
    setOpen(true);
  };

  const onThumbUpClick = () => {
    onFeedbackClick(id, 'up');
  };

  const showThumbUp = !downvote;
  const showThumbDown = !upvote;

  return (
    <ChatMessageWrapper isAgent={isAgent} className="chat-message-feedback">
      {showThumbDown && (
        <SvgWrapper onClick={onThumbDownClick}>
          {!downvote && <ThumbDown />}
          {downvote && <ThumbDownFilled />}
        </SvgWrapper>
      )}
      {showThumbUp && (
        <SvgWrapper onClick={onThumbUpClick}>
          {!upvote && <ThumbUp />}
          {upvote && <ThumbUpFilled />}
        </SvgWrapper>
      )}
      <SvgWrapper onClick={onCopyClick}>
        {/*
          TODO(Jenky): There's a transition of state when clicked
          https://www.figma.com/design/NNepakNWy07LaYO66Cb5xw/Chat-User-Flows?node-id=86-21084&m=dev
        */}
        <ContentCopy />
      </SvgWrapper>
      <FeedbackModal
        originalQuestion={responseOf!.content}
        aiResponse={content}
        open={open}
        onClose={() => setOpen(false)}
      />
    </ChatMessageWrapper>
  );
};

export default ChatMessageFeedback;
